import BasicButton from "../../components/Buttons/BasicButton";
import HeaderWithoutSignIn from "../../components/headers/HeaderWithoutSignIn";
import BasicForm from "../../components/textField/BasicForm";
import PasswordField from "../../components/textField/PasswordField";
import { validationMessage } from "../../consts/ValidationMessage";
import { getAuthDetails, getCognitoUser } from "../../utils/cognitoUtils";
import {
  validateRequiredFields,
  ValidationErrors,
} from "../../utils/validationUtils";
import { Box, Container, Link, Typography } from "@mui/material";
import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserSession,
} from "amazon-cognito-identity-js";
import React, { FC, useState, useEffect } from "react";
import { Link as RouterLink, useSearchParams } from "react-router-dom";

const SignInPage: FC = () => {
  const [searchParams] = useSearchParams();
  const fromManual = searchParams.get("from") === "manual";

  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({ loginId: "", password: "" });
  const [errors, setErrors] = useState<ValidationErrors>({});

  useEffect((): void => {
    localStorage.clear();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleClickShowPassword: () => void = (): void =>
    setShowPassword((prev) => !prev);

  const validate: () => boolean = (): boolean => {
    const requiredFields: string[] = ["loginId", "password"];
    const errorMessages = {
      loginId: `ログインID${validationMessage.REQUIRED}`,
      password: `パスワード${validationMessage.REQUIRED}`,
    };
    const newErrors = validateRequiredFields(
      form,
      requiredFields,
      errorMessages
    );
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSignIn: () => void = (): void => {
    if (!validate()) return;

    const user: CognitoUser = getCognitoUser(form.loginId);
    const authDetails: AuthenticationDetails = getAuthDetails(
      form.loginId,
      form.password
    );

    user.authenticateUser(authDetails, {
      onSuccess: (session: CognitoUserSession): void => {
        const idToken: string = session.getIdToken().getJwtToken();
        sessionStorage.setItem("idToken", idToken);
        sessionStorage.setItem("loginId", form.loginId);
        const authQuery = fromManual ? "?from=manual" : "";
        window.location.href = `/signin/auth${authQuery}`;
      },
      onFailure: () => {
        setErrors({ loginId: "", password: "ログインに失敗しました。" });
      },
    });
  };

  return (
    <>
      <HeaderWithoutSignIn />
      <Container maxWidth="xs">
        <Box mt={10} textAlign="center">
          <Typography variant="h5" gutterBottom>
            サインイン
          </Typography>
        </Box>
        <Box
          component="form"
          mt={10}
          display="flex"
          flexDirection="column"
          gap={3}
        >
          <BasicForm
            label={"ログインID"}
            name={"loginId"}
            value={form.loginId}
            onChange={handleChange}
            error={!!errors.loginId}
            helperText={errors.loginId}
          />
          <PasswordField
            label="パスワード"
            name="password"
            value={form.password}
            error={!!errors.password}
            helperText={errors.password}
            onChange={handleChange}
            showPassword={showPassword}
            onTogglePasswordVisibility={handleClickShowPassword}
          />
          <BasicButton onClick={handleSignIn} mt={5}>
            サインイン
          </BasicButton>
          <Box textAlign="center" mt={1} gap={5}>
            <Typography variant="body2" gutterBottom>
              アカウント作成は
              <Link component={RouterLink} to="/" variant="body2">
                サインアップ
              </Link>
            </Typography>
            <Typography variant="body2" gutterBottom>
              パスワードを忘れた方は
              <Link component={RouterLink} to="/pw/forgot" variant="body2">
                こちら
              </Link>
            </Typography>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default SignInPage;
